export const ADD_ALL_NOTIFICATIONS_GENERAL = 'ADD_ALL_NOTIFICATIONS_GENERAL'
export const REMOVE_GENERAL_NOTIFICATION = 'REMOVE_GENERAL_NOTIFICATION'
export const ADD_ALL_NOTIFICATIONS_SPECIFIC = 'ADD_ALL_NOTIFICATIONS_SPECIFIC'
export const REMOVE_SPECIFIC_NOTIFICATION = 'REMOVE_SPECIFIC_NOTIFICATION'